import React from "react";
import axios from "axios";
import store from "../store";
import { SESSION_EXPIRED } from "../store/actions";
import { constant } from "../Constants/constant";
import { Redirect } from "react-router-dom";
import { muchAndLearnMngtThunk } from "../store/actions/trainingmanagement/training.thunk";

export class ApiService {
  static async request(method, url, body) {
    const BaseURL = constant.HttpURL + `${url}`;

    const token = localStorage.getItem("token");

    const headers = {
      "Content-Type": "application/json",
    };

    // headers.append("Content-Type", "application/json");

    if (token) {
      headers["Authorization"] = `Bearer ${token}`;
    }

    const BodyRequest = body ? body : undefined;

    const request = await axios({
      method: method,
      url: BaseURL,
      headers: headers,
      data: BodyRequest,
    });

    return request;
  }

  static async get(url, body) {
    return await this.request(constant.GET, url, body);
  }
  static async post(url, body) {
    return await this.request(constant.POST, url, body);
  }
  static async put(url, body) {
    return await this.request(constant.PUT, url, body);
  }

  static async delete(url, body) {
    return await this.request(constant.DELETE, url, body);
  }

  static async patch(url, body) {
    return await this.request(constant.PATCH, url, body);
  }
}

const { dispatch } = store;

axios.interceptors.response.use(
  function (response) {
    // Any status code that lie within the range of 2xx cause this function to trigger
    // Do something with response data
    return response;
  },
  function (error) {
    // Any status codes that falls outside the range of 2xx cause this function to trigger
    // Do something with response error
    return Promise.reject(error).catch((err) => {
      // (async function () {
      //   if (err.response.status === 401) {
      //     console.log("You session has expired....Please login!");
      //     // return store.dispatch({ type: SESSION_EXPIRED, paylaod: true });
      //     // alert("You session has expired....Please login!");
      //     await dispatch(muchAndLearnMngtThunk.sessonExpred(true));
      //     // <Redirect to="/login" />;
      //   }
      // })();
      // if (err.response.status === 401) {
      //   console.log("You session has expired....Please login!");
      //   localStorage.setItem("sessionExp", true);
      // }
      console.log("Error status", err.response.status);
    });
  }
);



// WEBPACK FOOTER //
// ./src/services/ApiService.js